
import {
  BadgePercent,
  BriefcaseBusiness,
  Calculator,
  CalendarClock,
  ChartNoAxesCombined,
  ClipboardCheck,
  FileSignature,
  Languages,
} from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './css/Sales.css';

const salesItems = [
  {
    path: '/sales/meeting-manager',
    label: 'Menager leadów',
    icon: CalendarClock,
    accent: 'blue',
    description: 'Zarządzaj leadami, przypisaniami do handlowców oraz historią kontaktów.',
    requiresPermission: 'meetings:manage'
  },
  {
    path: '/sales/assigned-requests',
    label: 'Moje leady',
    icon: ClipboardCheck,
    accent: 'green',
    description: 'Zarządzaj leadami przypisanymi do Ciebie.',
    requiresPermission: 'meetings:assignable'
  },
  {
    path: '/sales/statistics',
    label: 'Statystyki',
    icon: ChartNoAxesCombined,
    accent: 'violet',
    description: 'Przeglądaj statystyki efektywności handlowców.',
    requiresPermission: 'meetings:statistics'
  },
  {
    path: '/sales/aluminium-deals',
    label: 'Oferty aluminium',
    icon: FileSignature,
    accent: 'amber',
    description: 'Automatyzacja rabatowania, naliczania montażu i tłumaczenia ofert aluminium.',
    requiresPermission: 'aluminium_deals:use|aluminium_deals:montage|aluminium_deals:translation',
    children: [
      {
        path: '/sales/aluminium-deals/discount',
        label: 'Rabatowanie',
        icon: BadgePercent,
        requiresPermission: 'aluminium_deals:use',
      },
      {
        path: '/sales/aluminium-deals/montage',
        label: 'Naliczanie montaży',
        icon: Calculator,
        requiresPermission: 'aluminium_deals:montage',
      },
      {
        path: '/sales/aluminium-deals/translation',
        label: 'Tłumaczenie ofert',
        icon: Languages,
        requiresPermission: 'aluminium_deals:translation',
      },
    ],
  },
];

const Sales = () => {
  const { hasPermission } = useAuth();

  // Filter sales items based on permissions
  const filteredItems = salesItems.filter(item => {
    if (item.requiresPermission) {
      // Check if permission contains OR operator (|)
      if (item.requiresPermission.includes('|')) {
        const permissions = item.requiresPermission.split('|');
        return permissions.some(perm => hasPermission(perm.trim()));
      }
      return hasPermission(item.requiresPermission);
    }
    return true;
  });

  return (
    <div className="page-container">
      <div className="page-header">
        <h2 className="sales-page-title"><BriefcaseBusiness aria-hidden="true" /> Dział Handlowy</h2>
        <p>Usługi i zasoby dla działu handlowego</p>
      </div>
      
      <div className="page-content">
        <div className="tiles-grid">
          {filteredItems.map((item) => {
            const Icon = item.icon;
            return (
              <Link key={item.path} to={item.path} className={`tile-card sales-tile sales-tile--${item.accent}`}>
                <span className="tile-icon sales-tile-icon" aria-hidden="true"><Icon strokeWidth={1.8} /></span>
                <h3 className="tile-title">{item.label}</h3>
                <p className="tile-description">{item.description}</p>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export { salesItems };
export default Sales;
